import React from "react";

/**
 * Card container. Sub-parts: CardHeader, CardFooter, CardRibbon.
 * @param {Object} props
 * @param {"default"|"elevated"|"outlined"} [props.variant="default"]
 */
export function Card({ variant = "default", className = "", children, ...rest }) {
  const cls = [
    "ds-card",
    variant === "elevated" && "ds-card-elevated",
    variant === "outlined" && "ds-card-outlined",
    className,
  ].filter(Boolean).join(" ");
  return <div className={cls} {...rest}>{children}</div>;
}

export function CardHeader({ children }) { return <div className="ds-card-header">{children}</div>; }
export function CardFooter({ children }) { return <div className="ds-card-footer">{children}</div>; }
export function CardTitle({ children }) { return <div className="ds-card-title">{children}</div>; }
export function CardBody({ children }) { return <div className="ds-card-body">{children}</div>; }
export function CardRibbon({ children }) { return <div className="ds-card-ribbon">{children}</div>; }
